var angular = require('angular');

var util = require('./util');

function Delivery(delivery, customer) {
  angular.extend(this, delivery);
  this.status = this.getStatus();
  this.statusTimestamp = util.toDate(this.deliveryStatusTimestamp);
  this.estimatedTimestamp = customer.estimatedTimestampDone;
}

Delivery.prototype.getStatus = function() {
  var status = this.deliveryStatus || 0;
  if (status === 1 || status === 2 || status === 12 || status === 13 || status === 15) {
    return 'delivered';
  } else if (status === 14) {
    return 'partiallyDelivered';
  } else if (status === 0 || status === 6) {
    return 'notDelivered';
  } else if (status === 11) {
    return 'cancelled';
  } else {
    return 'deviation';
  }
};

Delivery.prototype.delayed = function() {
  if (this.status === 'notDelivered') {
    return this.estimatedTimestamp && new Date() > this.estimatedTimestamp;
  } else {
    return this.statusTimestamp && this.estimatedTimestamp &&
           this.statusTimestamp > this.estimatedTimestamp;
  }
};

Delivery.prototype.notCancelled = function() {
  return this.status !== 'cancelled';
};

Delivery.prototype.allDelivered = function() {
  return this.status !== 'notDelivered' && this.status !== 'cancelled';
};

Delivery.prototype.showStatus = function() {
  return ! (this.deliveryStatus === 0 || this.deliveryStatus === 6 || this.deliveryStatus === 11);
};

Delivery.prototype.editClone = function() {
  var delivery = {};

  ['id', 'product', 'productCount', 'productCountAdjusted', 'orderLineId', 'parcelNumber', 'getStatus', 'deliveryStatus'].forEach(function(prop) {
    delivery[prop] = this[prop];
  }, this);

  return delivery;
};

module.exports = Delivery;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/delivery.js
 ** module id = 12
 ** module chunks = 1
 **/